import { render, staticRenderFns } from "./huodong.vue?vue&type=template&id=251e7d6b&scoped=true&"
import script from "./huodong.vue?vue&type=script&lang=js&"
export * from "./huodong.vue?vue&type=script&lang=js&"
import style0 from "./huodong.vue?vue&type=style&index=0&id=251e7d6b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251e7d6b",
  null
  
)

export default component.exports